import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostListener, Inject, Input, OnChanges, OnInit, PLATFORM_ID, ViewChild, ViewEncapsulation } from '@angular/core';
import { Currency } from 'projects/common/model/landingModel';
import { UpaService, UpaTarget } from 'projects/common/services/upa.service';
import { OfferCardData, OfferCardDataDriver, OfferCardDataInformationIcon, OfferCardDataPrice } from "../offer-card-data.model";
import { LoyaltyMode } from '@shopping-angular-components/loyalty'
import { EvaSize } from '@shopping-angular-components/loader';
import { MediaPictureService } from "../../../services/media-picture.service";
import { ReplaceParamsPipe } from "../../../pipes/replace-params.pipe";
import { Device } from 'projects/common/model/Device';
import { HotelsBoxService } from 'projects/common/services/hotelsBox.service';

declare var window: any;

@Component({
  selector: 'cluster',
  template: `
    <div class="cluster-container -eva-3-mb-lg" target="_blank" (click)="onClusterClicked($event)">
      <div class="distinction {{clusterTag}}">
          <i class="-eva-3-mr-sm eva-3-icon-hotels -eva-3-icon-sm"></i>{{"hotelInCity.hotelDistinctionSearched" | translate}}
      </div>
      <div class="cluster-container-clickable" title="{{data.link.title}}">
        <div class="cluster eva-3-offer-card eva-3-card -eva-3-shadow-line -eva-3-shadow-2-hover {{clusterTag}}" #cluster>
          <div class="cluster-image" [ngClass]="isMobile && outstandingDriverData ? 'with-outstanding-driver' : ''">
            <loader
              class="loader"
              [flow]="flow"
              product="nymeria-gui"
              [show]="true"
              [size]="evaSizes.MEDIUM"
            ></loader>
            <img
              *ngIf="showClusterImage && !data.pictures_carrousel && data.picture_link && mediaPictureService.getMediaUrl(data.picture_link) as pictureLink"
              class="cluster-image-main"
              src="{{pictureLink}}/465x445"
              loading="lazy"
              [alt]="data.product_text + '-' + data.main_text">
            <media-picture-gallery
              *ngIf="showClusterImage && height!==null && width!==null && height > 0 && width > 0 && data.pictures_carrousel"
              product="nymeria-gui"
              [flow]="flow"
              [pictures]="pictureCarrouselKeys()"
              [pictureHeight]="height"
              [pictureWidth]="width"
              navigationSize="-sm"
              [showNavigationOnHover]="false"
              [useIntersectionObserver]="true"
              [navigation]="!isMobile"
              [allowTouchMove]="isMobile"
              [pagination]="isMobile"
            ></media-picture-gallery>
          </div>
          <div class="cluster-content">

            <ng-container [ngTemplateOutlet]="outstandingDriver" *ngIf="isMobile" [ngTemplateOutletContext]="{class: 'offer-card-main-driver'}"></ng-container>
            <a *ngIf="data.main_text" class="offer-card-title-link" target="_blank" href="{{href}}" (click)="onTitleClicked($event, href)">{{data.main_text}}</a>
            <div class="offer-card-description">{{data.auxiliary_text}}</div>
            <div class="offer-card-rating" *ngIf="data.overall_rating || (data.information_icons && data.information_icons.length > 0)">
              <ng-container *ngIf="data.overall_rating">
                <review-score [score]="data.overall_rating"></review-score>
                <div class="offer-card-rating-stars" *ngIf="data.stars">
                  <i *ngFor="let star of stars" class="-eva-3-icon-xsm eva-3-icon-star-filled"></i>
                </div>
              </ng-container>

              <div *ngIf="data.overall_rating && data.information_icons" class="divider"></div>
              <div class="offer-card-icons-container" *ngIf="data.information_icons && data.information_icons.length > 0">
                <div *ngFor="let icon of data.information_icons" class="icon-container"
                  [ngClass]="icon.tooltip_text? 'eva-3-tooltip -white -top '+(isMobile ?'-center -sm': '-right') : ''">
                  
                  <tooltip backgroundColor="-white" [position]="'-top ' + (isMobile ? '-center' : '-right')" product="nymeria-gui" flow="landing"
                    [openOnHover]="!isMobile && hasTooltipText(icon)" [openOnClick]="isMobile && hasTooltipText(icon)" [closeOnOutsideClick]="true">  
                    <span label class="icon-information">
                      <i class="eva-3-icon-{{icon.icon}} -eva-3-icon-sm"></i>
                    </span>
                    <p tooltip-content class="tooltip-text">{{icon.tooltip_text}}</p>
                  </tooltip>
                
                </div>
              </div>
            </div>
            <div class="offer-card-benefits-container" *ngIf="data.drivers && data.drivers.length > 0">
              <ul class="offer-card-benefits">
                <li *ngIf="outstandingDriverData && !isMobile" class="offer-card-benefit-item">
                  <ng-container [ngTemplateOutlet]="outstandingDriver"></ng-container>
                </li>
                <li *ngFor="let driver of data.drivers" class="offer-card-benefit-item">
                  
                  <tooltip backgroundColor="-white" position='-top -right' [openOnHover]="!!driver.tooltip?.text" product="nymeria-gui" flow="landing">
                    <span label class="eva-3-driver" [ngClass]="driver.driver_style ? driver.driver_style : (driver.tooltip && driver.tooltip.text) ? '-information' : ''">
                      <span class="driver-text">
                        <i class="-eva-3-mr-xsm eva-3-icon-info-circle" *ngIf="driver.tooltip && driver.tooltip.text"></i>
                        {{driver.text}}
                      </span>
                    </span>
                    <p tooltip-content class="tooltip-text">{{driver.tooltip?.text}}</p>  
                  </tooltip>
                  
                </li>
              </ul>
            </div>
            <div class="offer-card-room-type eva-3-h6 -eva-3-tc-gray-0" *ngIf="data.room_type_description">
              {{data.room_type_description}}
            </div>
            <div class="offer-card-description-container" *ngIf="data.description">
              <p class="offer-card-description-content offer-card-description" [innerHTML]="data.description"></p>
            </div>
          </div>

          <cluster-pricebox *ngIf="!isMobile && !price?.prepaid_price_in_points"
              [data]="data" [currency]="currency" [loyaltyMode]="loyaltyMode"
              [flow]="flow" [locale]="locale" [sboxAutocomplete]="sboxAutocomplete"
              [index]="index" [moduleId]="moduleId" [uniqueId]="uniqueId">
          </cluster-pricebox>

          <pricebox-with-points *ngIf="!isMobile && price?.prepaid_price_in_points"
              [price]="price" [currency]="currency" [locale]="locale"
              [moduleId]="moduleId"[product]="this.product"
              [positionLabelClassName]="'-top-left'">
          </pricebox-with-points>

          <offer-card-pricebox *ngIf="isMobile"
            [data]="data" [currency]="currency" [loyaltyMode]="loyaltyMode"
            [flow]="flow" [locale]="locale">
          </offer-card-pricebox>
        </div>
      </div>
    </div>

    <ng-template #outstandingDriver let-class="class">
      <span class="eva-3-driver" [ngClass]="outstandingDriverData.driver_style + ' ' +  (class ? class : '')"
            *ngIf="outstandingDriverData">
        <span class="driver-text" [ngClass]="outstandingDriverData.text_style" alt="">
          <img *ngIf="outstandingDriverData.icon_src" loading="lazy"
            [ngClass]="outstandingDriverData.icon ? outstandingDriverData.icon : ''"
            [src]="'/landings-static/' + outstandingDriverData.icon_src" alt="">
          <i class="-eva-3-mr-xsm" [ngClass]="outstandingDriverData.icon"
              *ngIf="outstandingDriverData.icon && !outstandingDriverData.icon_src"></i>
          {{outstandingDriverData.text}}
        </span>
      </span>
    </ng-template>
  `,
  styleUrls: ['./cluster.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ClusterComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() data: OfferCardData;
  @Input() clusterTag: string;
  @Input() index: number;
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() uniqueId?: string;
  @Input() currency: Currency;
  @Input() locale: string;
  @Input() loyaltyMode: LoyaltyMode | null;
  @Input() product;
  @Input() flow;
  @Input() device: Device;
  @Input() sboxAutocomplete?: boolean;

  evaSizes = EvaSize;

  stars: Array<any>;
  price: OfferCardDataPrice;
  @ViewChild("cluster") cluster: ElementRef;
  showClusterImage = false;
  height: number | null = null;
  width: number | null = null;
  href?: string;
  paymentsMediaKey?: string;
  outstandingDriverData?: OfferCardDataDriver;
  isMobile: boolean;
  isHotelVrOrPromotion: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private upaService: UpaService,
    private replaceParamsPipe: ReplaceParamsPipe,
    public mediaPictureService: MediaPictureService,
    private hotelsBoxService: HotelsBoxService
  ) { }

  ngOnInit(): void {
    this.initStars();
    this.initPrice();
    this.isHotelVrOrPromotion = ['hotels', 'vacation_rentals', 'promotions'].includes(this.data.product);
    this.showClusterImage = isPlatformBrowser(this.platformId);
    this.href = this.getHref();
    this.paymentsMediaKey = this.mediaPictureService.getMediaUrl(this.data.payments_media_key);
    if (this.data.outstanding_driver || this.data.outstanding_text) {
      this.outstandingDriverData = {
        text: this.data.outstanding_text,
        type: "",
        driver_style: "-information",
        text_style: "",
        ...(this.data.outstanding_driver || {})
      };
    }
    this.isMobile = this.device?.type == "MOBILE";
  }

  ngOnChanges(): void {
    this.initPrice();
    this.href = this.getHref();
    this.isMobile = this.device?.type == "MOBILE";
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.onResize());
  }

  private initStars(): void {
    if (this.data.stars) {
      this.stars = new Array(Number(this.data.stars)).fill({});
    }
  }

  private initPrice(): void {
    if (this.data.offer_alternatives) {
      this.price = this.data.offer_alternatives[0].price[this.currency.code];
    } else if (this.data.price) {
      this.price = this.data.price[this.currency.code];
    }
  }

  onClusterClicked(event: MouseEvent): void {
    if (this.href) {
      this.upaService.trackClickTopic({
        label: this.data.product,
        moduleId: this.moduleId,
        moduleIndex: this.moduleIndex,
        uniqueId: this.uniqueId,
        positionIndex: this.index,
        target: UpaTarget.OFFER,
        href: this.href
      }, event);
    }
    if (this.flow != 'landing:detail' && this.isHotelVrOrPromotion && window.hotelsBox && this.sboxAutocomplete) {
      event.preventDefault();
      this.hotelsBoxService.updateHotelsData(this.data);
    }
  }

  onTitleClicked(event: MouseEvent, href: any): void { 
    if (href){
      event.preventDefault();
      event.stopPropagation();
      window.location.href = href;
    }    
  }

  pictureCarrouselKeys(): string[] {
    return this.data.pictures_carrousel.map(el => {
      const parts = el.split("/");
      return parts[parts.length - 1];
    })
  }

  @HostListener('window:resize')
  onResize(): void {
    if (this.showClusterImage) {
      const maxWidth = this.cluster.nativeElement?.clientWidth ?? globalThis.innerWidth;
      const deviceType = globalThis.innerWidth >= 1024 ? 'DESKTOP' :
        globalThis.innerWidth > 768 ? 'TABLET' : 'MOBILE';
      this.height = deviceType != 'DESKTOP' ? 200 : 299;
      this.width = deviceType != 'DESKTOP' ? maxWidth : 300;
    }
  }

  getRibbon(): string {
    return this.price.promo.ribbon || `- ${this.price.promo.discount}%`;
  }

  hasTooltipText(icon: OfferCardDataInformationIcon): boolean {
    return !!icon?.tooltip_text;
  }

  private getHref(): string | undefined {
    if (this.data?.link?.url) {
      return this.replaceParamsPipe.transform(this.data.link.url, {
        currency: this.currency?.code,
        price: this.price?.total_amount_not_formatted
      })
    }
  }
}
